import CustomDialogTitle from "../../unit/CustomDialogTitle";

const CustomApplicationDialogTitle = ({ ...props }) => {
  const record = props.record;
  let appStatus = record?.sStatus;
  let pagetitle = appStatus;
  // console.log("CustomApplicationDialogTitle record===>", appStatus);
  if (
    appStatus == "New" ||
    appStatus == "" ||
    appStatus == "Check" ||
    appStatus == "restart"
  ) {
    if (record?.showNextprocess == 1) {
      pagetitle = "Ready for Screening";
    } else {
      pagetitle = "Pending Verification";
    }
  } else if (appStatus == "Initial Review") {
    pagetitle = "Ready for Initial Review";
  } else if (appStatus == "Final Review") {
    pagetitle = "Ready for Final Review";
  } else if (appStatus == "To Notify") {
    pagetitle = "Ready for Notification";
  } else if (
    appStatus == "CounteredAndPreApproved" ||
    appStatus == "Countered" ||
    appStatus == "Pre-Approved"
  ) {
    if (record?.sApplicationResponse == "Accept") {
      pagetitle = "Ready for Final Approval";
    } else {
      pagetitle = "Pending Acceptance";
    }
  } else if (record?.sStatus == "Completed" || record?.sStatus == "Approved") {
    // $query->where("applogExecute.sExecuteStatus", "=", "Closing Dos Received");
    if (record?.sExecuteStatus == "Closing Dos Received") {
      pagetitle = "Ready for Disbursement";
    } else {
      pagetitle = "Pending Closing";
    }
  } else if (record?.sStatus == "Hold") {
    pagetitle = "On Hold (Last 90 Days)";
  } else if (record?.sStatus == "Expired") {
    pagetitle = "Expired Applications";
  }
  return (
    <CustomDialogTitle
      // title={`${record?.sStatus} -${record.showNextprocess} Application`}
      title={`${pagetitle} Application`}
      subTitle={props.subTitle}
    />
  );
};

export default CustomApplicationDialogTitle;
